import React, { Component } from 'react'
import { Header, ActionCard, PageWrapper } from '../components'

class FAQs extends Component {
  state = {}
  render() {
    return (
      <React.Fragment>
        <Header
          title={'Frequently Asked Questions'}
          icon="arrowBack"
          onClickBack={() => this.props.history.goBack()}
          color="#fff"
        />
        <PageWrapper viewPadding="22.4% 3.9% 6%" height="100%">
          <ActionCard
            label="I already don’t trust most food brands and labels, why should I trust GreenChoice?"
            onTouch={() => this.props.history.push('/faq/why-trust-greenchoice')}
            margin="0 0 10px 0"
          />
          <ActionCard
            label="How does GreenChoice make money?"
            onTouch={() => this.props.history.push('/faq/make-money')}
            margin="0 0 10px 0"
          />
          <ActionCard
            label="What does the PBC mean? I usually see LLC or Corp. after a company name."
            onTouch={() => this.props.history.push('/faq/pbc-mean')}
            margin="0 0 10px 0"
          />
          <ActionCard
            label="Does GreenChoice, PBC have a conflict of interest policy?"
            onTouch={() => this.props.history.push('/faq/pbc-interest-policy')}
            margin="0 0 10px 0"
          />
          <ActionCard
            label="What values guide the GreenChoice team?"
            onTouch={() => this.props.history.push('/faq/values-guide')}
            margin="0 0 10px 0"
          />
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default FAQs



// WEBPACK FOOTER //
// ./src/pages/FAQs.js